module.exports = __webpack_public_path__ + "img/initImage.6f8f67d1.png";